import { render, staticRenderFns } from "./part_1.vue?vue&type=template&id=182a4c50&scoped=true&"
import script from "./part_1.vue?vue&type=script&lang=js&"
export * from "./part_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182a4c50",
  null
  
)

export default component.exports